import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YesNoInput from '../YesNoInput';
import './YesNoInputGroup.scss';
var valueForOption = function valueForOption(option, value) {
  var optionValue = value && value.find(function (v) {
    return v.id === option.id;
  });
  return optionValue && optionValue.selected;
};
var error = function error(formKey, id, errors) {
  return errors && errors["".concat(formKey, "_").concat(id)] === 'radio_button';
};
var hasErrors = function hasErrors(formKey, options, errors) {
  if (options.length > 0 && Object.entries(errors).length > 0) {
    return options.some(function (option) {
      return errors["".concat(formKey, "_").concat(option.id)] === 'radio_button';
    });
  }
  return false;
};
var requiredError = function requiredError(formKey, options, errors) {
  if (hasErrors(formKey, options, errors)) {
    return /*#__PURE__*/React.createElement("div", {
      className: "body-text-2 with-error-text mt-2 mb-2"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-exclamation-triangle"
    }), ' ', "Required!");
  }
  return null;
};
var YesNoInputGroup = /*#__PURE__*/function (_Component) {
  function YesNoInputGroup(props) {
    var _this;
    _classCallCheck(this, YesNoInputGroup);
    _this = _callSuper(this, YesNoInputGroup, [props]);
    _this.onYesNoChange = _this.onYesNoChange.bind(_this);
    return _this;
  }
  _inherits(YesNoInputGroup, _Component);
  return _createClass(YesNoInputGroup, [{
    key: "onYesNoChange",
    value: function onYesNoChange(option, val) {
      var _this$props = this.props,
        value = _this$props.value,
        onAnswerChange = _this$props.onAnswerChange;
      // Remove and replace any selection for this option
      var newValue = value.filter(function (v) {
        return v.id !== option.id;
      });
      onAnswerChange([].concat(_toConsumableArray(newValue), [{
        id: option.id,
        selected: val
      }]));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        formKey = _this$props2.formKey,
        options = _this$props2.options,
        value = _this$props2.value,
        errors = _this$props2.errors,
        showIndex = _this$props2.showIndex;
      return /*#__PURE__*/React.createElement("div", {
        className: "yes-no-input-group body-text-2"
      }, requiredError(formKey, options, errors), options.map(function (option, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: option.id
        }, /*#__PURE__*/React.createElement("div", {
          className: "option-container"
        }, /*#__PURE__*/React.createElement("span", {
          className: error(formKey, option.id, errors) ? 'with-error-text' : ''
        }, showIndex ? "".concat(index + 1, ". ") : '', option.name || option.description), /*#__PURE__*/React.createElement(YesNoInput, {
          className: "yes-no-container",
          id: formKey + option.id,
          onAnswerChange: function onAnswerChange(val) {
            return _this2.onYesNoChange(option, val);
          },
          value: valueForOption(option, value),
          labelError: error(formKey, option.id, errors)
        })));
      }));
    }
  }]);
}(Component);
YesNoInputGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    selected: PropTypes.oneOf(['Yes', 'No'])
  })),
  onAnswerChange: PropTypes.func.isRequired,
  formKey: PropTypes.string.isRequired,
  errors: PropTypes.shape({}),
  showIndex: PropTypes.bool
};
YesNoInputGroup.defaultProps = {
  value: [],
  errors: {},
  showIndex: false
};
export default YesNoInputGroup;